import React from "react";
import { Grid, Button } from "@mui/material";
import {
  STEP_ACTION_BAR_SX,
  STEP_ACTION_BUTTON_SX,
  STEP_CANCEL_BUTTON_SX,
  STEP_CLOSE_BUTTON_SX,
} from "./stepComponentStyles";

function StepActionBar({
  isLoading = false,
  showBack = true,
  showCancel = true,
  showNext = false,
  showSubmit = false,
  showClose = false,
  onBack,
  onCancel,
  onNext,
  onClose,
  onSubmitClick,
  backLabel = "Back",
  cancelLabel = "Cancel",
  nextLabel = "Next",
  submitLabel = "Submit",
  closeLabel = "Close",
}) {
  return (
    <Grid item xs={12} sx={STEP_ACTION_BAR_SX}>
      {showBack && (
        <Button
          variant="outlined"
          onClick={onBack}
          sx={STEP_ACTION_BUTTON_SX}
          disabled={isLoading}
        >
          {backLabel}
        </Button>
      )}

      {showCancel && (
        <Button
          variant="outlined"
          color="secondary"
          onClick={onCancel}
          sx={STEP_CANCEL_BUTTON_SX}
          disabled={isLoading}
        >
          {cancelLabel}
        </Button>
      )}

      {showNext && (
        <Button
          variant="contained"
          color="primary"
          onClick={onNext}
          sx={STEP_ACTION_BUTTON_SX}
          disabled={isLoading}
        >
          {nextLabel}
        </Button>
      )}

      {showSubmit && (
        <Button
          variant="contained"
          color="primary"
          type={onSubmitClick ? "button" : "submit"}
          onClick={onSubmitClick}
          sx={STEP_ACTION_BUTTON_SX}
          disabled={isLoading}
        >
          {submitLabel}
        </Button>
      )}

      {showClose && (
        <Button
          variant="contained"
          color="success"
          onClick={onClose}
          sx={STEP_CLOSE_BUTTON_SX}
        >
          {closeLabel}
        </Button>
      )}
    </Grid>
  );
}

export default StepActionBar;